(ns client-login.views
  (:require
   [reagent.core :as r]
   [oops.core :refer [oget]]
   [very.re-frame.core :as rf :refer [<sub >evt]]
   [css.core :refer [defstyled] :as css]
   [css.form :as form]
   [css.typography :as typo]
   [cljss.core :as cljss]
   [main.common :as common]))

(defstyled button-grid-s :div
  {:justify-content "center"
   :grid-template-columns "1fr"
   :width "100%"
   :margin "auto"
   :grid-gap "1.5rem 0"
   :display "grid"
   :max-width "25rem"})

(defstyled button-anchor-s :a
  {:display "block"
   :text-decoration "none"})

(defn button-anchor [login]
  [button-anchor-s {:href (:uri login)
                    :target "_blank"}
   [form/secondary-button-s {:width "100%"
                             :size "large"} (:name login)]])

(defn client-login []
  (let [partner (rf/subscribe [:partner])]
    (fn []
      (let [td {:name "TD Ameritrade"
                :uri "https://www.advisorclient.com/advisorclient/p/gridLogin"}
            fidelity {:name "Fidelity"
                      :uri "https://login.fidelity.com/ftgw/Fas/Fidelity/RtlCust/Login/Init?AuthRedUrl=https://oltx.fidelity.com/ftgw/fbc/ofsummary/defaultPage"}
            logins (concat [td fidelity] (:logins @partner))]
        [common/grid-s {:grid-column "content"
                        :align-items "center"
                        :justify-content "center"}
         [:div
          [typo/h1 {:margin "4.5rem 0 3rem"
                    :text-align "center"} "Access your accounts"]
          (into [button-grid-s] (concat [[form/secondary-button-s {:type "button"
                                                                   :size "large"
                                                                   :on-click #(rf/>evt [:sso-login :orion])
                                                                   :width "100%"} "Client Experience Optimizer"]]
                                        (map #(vector button-anchor %) logins)))]]))))
